/**
 * All the api end point const for strong signals.
 */
export enum ApiConstants {
  FETCH_CLUSTERS = '/strongsignals/cluster/getClusters',
  FETCH_CLUSTERS_DETAIL = '/strongsignals/cluster/getClusterDetail'
}

/**
 * Field Uri for element created from cluster.
 */
export const CLUSTER_SOURCE_URI = 'clusterSource';
